export default {
  /**
   * Use: {{fields.name | cut}}
   * Use: {{fields.name | cut(30)}}
   * @param str
   * @param len
   * @returns {string}
   */
  cut: function (str, len = 70) {
    if (str) {
      let cuted = str.toString().substring(0, len)
      if (cuted.length < str.toString().length) {
        cuted = `${cuted}...`
      }
      return cuted
    }
    return ''
  },
  /**
   * Use: $options.filters.stripHtml
   * Use: {{fields.name | stripHtml}}
   * @param str
   * @returns {*}
   */
  stripHtml: function (str) {
    if (str) {
      str = str.toString().replace(/(<([^>]+)>)/ig, ' ')
    }
    return str
  },
  firstLetterCapital: function (str) {
    if (str) {
      return str.toString().charAt(0).toUpperCase() + str.slice(1)
    }
    return ''
  }
}
